import Navbar from "./Navbar";
import Dashboard from "./Dashboard";

function App() {
  return (
    <>
      <Navbar />
      <Dashboard />
    </>
  );
}

export default App;
